import React, { Component } from 'react'
import { withRouter, Link } from "react-router-dom";
import { Image, Nav, Accordion } from 'react-bootstrap'
import { Scrollbars } from 'react-custom-scrollbars'
import logo from '../../../images/logo.svg'
import small_logo from '../../../images/small-logo.png';
import vignanLogo from "../../../images/vignan_logo.png";
import vignanShortLogo from "../../../images/vignan_short_logo.png";
import * as Cookies from "es-cookie";
import gifImage from "../../../images/new-gif-icon.png";
import pulseImage from "../../../images/pulse.png";
import './_navbars.scss';
import StartingModal from '../../components/home/starting_modal/MobileStartingModal';
import AccordionArrow from './AccordionArrow';

import HomeEamcet from "../../../images/images1/home_eamcet.png"
import IpeLectures from "../../../images/images1/ipe_classes.png"
import MockTest from "../../../images/images1/mocktest_eamcet.png"
import Quiz from "../../../images/images1/quiz_eamcet.png"
import PreviousPapers from "../../../images/images1/practisetest_eamcet.png"
import ShortNotes from "../../../images/images1/shortnotes_eamcet.png"
import Formulas from "../../../images/images1/formula_eamcet.png"
import Subscriptions from "../../../images/images1/subscription_eamcet.png"
import PractiseTest from "../../../images/images1/practisetest_eamcet.png"
// import BlogEamcet from "../../../images/images1/blog_eamcet.png"
import BluePrint from "../../../images/images1/eamcet_blue_print.png";
import CrashCourse from "../../../images/images1/eamcet_crash_course.png";
import EamcetPrevious from "../../../images/images1/eamcet_prev_paper.png";
import RankPredictor from "../../../images/images1/eamcet_rankPredictor.png";
import ReactGA from 'react-ga';
import { GoogleAnalyticsArray } from '../../pages/GoogleAnalytics';
import Foundation from '../../../images/images1/foundationmenu.png';
import foundationNavIcon from '../../../images/foundation logo white.png'
import foundationtest from '../../../images/images1/foundation_test.png'
import longtermCourse from '../../../images/images1/longtermcourse.png'
import partnerOffers from '../../../images/images1/partner_offers.png';
import college_logo from '../../../images/registrations/dinesh_publications.gif';


import { graphql } from "react-apollo";
import gql from "graphql-tag";
import * as compose from 'lodash.flowright';
import StudentTargettingPopup from './StudentTargettingPopup'
import BrandLogo from "./BrandLogo";
import { brandLoginUrl } from "../../../utils/brandLogin";

const GET_CROSSSELLING_POPUP = gql`
query($mobile:String,$app_module_id:Int,$source:Int){
    getCrossSellingEnabled(mobile: $mobile, app_module_id: $app_module_id, source: $source) {
        pop_enabled
        mobile_image_path
        web_image_path
        navigation_url
        button_name
      }
}
`;


const renderThumb = ({ style, ...props }) => {
    const thumbStyle = {
        borderRadius: 6,
        width: '3px',
        backgroundColor: 'rgba(255, 255, 255, 0.3)'
    };
    return <div style={{ ...style, ...thumbStyle }} {...props} />;
};

class MobileAsideNavbar extends Component {
    constructor(props) {
        super(props)
        this.state = {
            StartingModalShow: false,
            targetPopup: true,
            targetPopupData: {},
            rizeeLogo: true
        }
        if (JSON.parse(localStorage.getItem("isStudentUserValid")) != "") {
            this.isStudentUserValid = JSON.parse(localStorage.getItem("isStudentUserValid"));

        }
    }
    componentDidMount = () => {

        if (localStorage.getItem("homemodal") == "true") {
            this.setState({
                StartingModalShow: true
            })
        }
        // const domain = window.location.hostname;
        // const path = window.location.pathname;
        // let rizeeLogo = domain === "rizee.in";


        // this.setState({
        //     rizeeLogo: rizeeLogo
        // });
    }
    onHide = () => {

        this.setState({ StartingModalShow: false, targetPopup: false });
        localStorage.setItem("homemodal", "false");
    }
    logout = () => {
        if (Cookies.get("studenttoken") !== undefined) {
            Cookies.remove("studenttoken");
            Cookies.remove("studentrefreshtoken");
            Cookies.remove("studentusername");
            Cookies.remove("studentemail");

            Cookies.remove("mobile");
            Cookies.remove("classid");
            Cookies.remove("examid");
            Cookies.remove("exam_name");
            Cookies.remove("mobileverified");
            Cookies.remove("targetyear");
            Cookies.remove("videos");
            Cookies.remove("branch_name");
            Cookies.remove("role", "");
            Cookies.remove("profile_pic");
            Cookies.remove("student_userlevel");
            Cookies.remove("stulogintype", "");
            localStorage.removeItem('profile_pic');
            localStorage.removeItem('studentglobals');
            localStorage.removeItem('globalsubjects');
            localStorage.removeItem("packageplan");
            if (brandLoginUrl(Cookies.get("institution_id"))) {
                window.location.href = brandLoginUrl(Cookies.get("institution_id"));
            } else {
                this.props.history.push("/student/login");
            }
        }
        //this.props.onClick();
    };
    getAccordianActive = () => {
        switch (this.props.history.location.pathname) {

            // Analysis
            case "/student/result-analysis":
                return 1;
            case "/student/practice-exam-analysis":
                return 1;
            case "/student/strength-analysis":
                return 1;
            case "/student/time-analysis":
                return 1;
            case "/student/complexity-analysis":
                return 1;
            case "/student/error-analysis":
                return 1;
            case "/student/questiontype-analysis":
                return 1;
            case "/student/get-ready-for-exam":
                return 2;
            case "/student/bookmark":
                return 2;
            case "/student/notes":
                return 2;
            case "/student/practise_test":
                return 2;
            case "/student/Chapter-wise-questions":
                return 2;
            case "/student/StateShortNotes":
                return 2;
            case "/student/FormulaeSheets":
                return 2;
            case "/student/StateBluePrint":
                return 2;
            case "/student/Eamcet-Video-classes":
                return 2;
            case "/student/institute-revison-materials":
                return 2;
            case "/student/ai":
                return 2;

            case "/student/chapter-wise-practise":
                return 2;
            default: return 0;
        }
    }

    getActiveClassTwo = (link) => {
        if (link === this.props.history.location.pathname)
            return "collapse-item active";
        else
            return "collapse-item";
    }

    // Chapter Wise Learning is only worth showing if at least one child item
    // renders. isuserValid flags are restrictions: true means hidden.
    hasChapterWiseLearningItems = () => {
        const access = this.props.isuserValid || {};
        const examid = Cookies.get("examid");
        const isStateExam = examid == 3 || examid == 6 || examid == 7 || examid == 8;
        return (
            (isStateExam &&
                (access.Chapterpreviousquestions != true ||
                    access.ST_ShortNotes != true ||
                    access.ST_RevisionMaterial != true ||
                    access.ChapterVideos != true)) ||
            access.ST_BluePrint != true
        );
    }

    getActiveClass = (link) => {
        if (link === this.props.history.location.pathname)
            return "nav-link active";

        else if (this.props.history.location.pathname === "/student/subjects" && link === "/student/learn-practice")
            return "nav-link active";

        else if (this.props.history.location.pathname === "/student/liveClasses" && link === "/student/liveClasses")
            return "nav-link active";

        else if (this.props.history.location.pathname === "/student/rapidRevision/liveClasses" && link === "/student/rapidRevision/liveClasses")
            return "nav-link active";

        else if (this.props.history.location.pathname === "/student/BluePrint" && link === "/student/BluePrint")
            return "nav-link active";
        else if (this.props.history.location.pathname === "/student/syllabus" && link === "/student/syllabus")
            return "nav-link active";

        else if (this.props.history.location.pathname === "/student/PreviousPapers" && link === "/student/PreviousPapers")
            return "nav-link active";

        else if (this.props.history.location.pathname === "/student/ShortNotes" && link === "/student/ShortNotes")
            return "nav-link active";

        else if (this.props.history.location.pathname === "/student/subject/topics" && link === "/student/learn-practice")
            return "nav-link active";

        else if (this.props.history.location.pathname === "/student/pre-exam-test" && link === "/student/learn-practice")
            return "nav-link active";

        else if (this.props.history.location.pathname === "/student/subject/chapter" && link === "/student/learn-practice")
            return "nav-link active";

        else if (this.props.history.location.pathname === "/student/subject/chapter-status" && link === "/student/learn-practice")
            return "nav-link active";

        else if (this.props.history.location.pathname === "/student/subject/practice-exam-history" && link === "/student/learn-practice")
            return "nav-link active";

        else if (this.props.history.location.pathname === "/student/subject/start-watching" && link === "/student/learn-practice")
            return "nav-link active";

        else if (this.props.history.location.pathname === "/student/subject/start-learning" && link === "/student/learn-practice")
            return "nav-link active";

        else if (this.props.history.location.pathname === "/student/subject/short-notes" && link === "/student/learn-practice")
            return "nav-link active";

        else if (this.props.history.location.pathname === "/student/subject/start-error-exam" && link === "/student/learn-practice")
            return "nav-link active";

        else if (this.props.history.location.pathname === "/student/subject/start-error-exam/error-exam" && link === "/student/learn-practic")
            return "nav-link active";

        else if (this.props.history.location.pathname === "/student/exams/schedule-exam" && link === "/student/exams/schedule-exam")
            return "nav-link active";

        else if (this.props.history.location.pathname === "/student/exams/adaptive-exam" && link === "/student/exams")
            return "nav-link active";

        else if (this.props.history.location.pathname === "/student/exams/custom-exam" && link === "/student/exams")
            return "nav-link active";

        else if (this.props.history.location.pathname === "/student/exams/error-exam" && link === "/student/exams/error-exam")
            return "nav-link active";
        else if (this.props.history.location.pathname === "/student/videos/recently-watched" && link === "/student/videos")
            return "nav-link active";

        else if (this.props.history.location.pathname === "/student/exams/previous-paper-exam" && link === "/student/exams")
            return "nav-link active";

        else if (this.props.history.location.pathname === "/student/exams/custom-previous-paper-exam" && link === "/student/exams")
            return "nav-link active";

        else if (this.props.history.location.pathname === "/student/get-ready-for-exam/chapter-exam" && link === "/student/get-ready-for-exam")
            return "nav-link active";

        else if (this.props.history.location.pathname === "/student/get-ready-for-exam/cumulative-exam" && link === "/student/get-ready-for-exam")
            return "nav-link active";

        else if (this.props.history.location.pathname === "/student/get-ready-for-exam/semigrand-exam" && link === "/student/get-ready-for-exam")
            return "nav-link active";

        else if (this.props.history.location.pathname === "/student/get-ready-for-exam/grand-exam" && link === "/student/get-ready-for-exam")
            return "nav-link active";

        else if (this.props.history.location.pathname === "/student/get-ready-for-exam/get-ready-shortnotes-and-materials" && link === "/student/get-ready-for-exam")
            return "nav-link active";

        else if (this.props.history.location.pathname === "/student/get-ready-for-exam/get-ready-shortnotes/single-shortnote" && link === "/student/get-ready-for-exam")
            return "nav-link active";

        else if (this.props.history.location.pathname === "/student/get-ready-for-exam/history" && link === "/student/get-ready-for-exam")
            return "nav-link active";

        else if (this.props.history.location.pathname === "/student/bookmark/videos" && link === "/student/bookmark")
            return "nav-link active";

        else if (this.props.history.location.pathname === "/student/bookmark/videos/watch-video" && link === "/student/bookmark")
            return "nav-link active";

        else if (this.props.history.location.pathname === "/student/bookmark/shortnotes-and-materials" && link === "/student/bookmark")
            return "nav-link active";

        else if (this.props.history.location.pathname === "/student/bookmark/shortnotes-and-material/single-shortnote" && link === "/student/bookmark")
            return "nav-link active";

        else if (this.props.history.location.pathname === "/student/bookmark/practice-questions" && link === "/student/bookmark")
            return "nav-link active";

        else if (this.props.history.location.pathname === "/student/bookmark/exam-questions" && link === "/student/bookmark")
            return "nav-link active";

        else if (this.props.history.location.pathname === "/student/notes/videos" && link === "/student/notes")
            return "nav-link active";

        else if (this.props.history.location.pathname === "/student/notes/videos/watch-video" && link === "/student/notes")
            return "nav-link active";

        else if (this.props.history.location.pathname === "/student/notes/shortnotes-and-materials" && link === "/student/notes")
            return "nav-link active";

        else if (this.props.history.location.pathname === "/student/notes/shortnotes-and-material/single-shortnote" && link === "/student/notes")
            return "nav-link active";

        else if (this.props.history.location.pathname === "/student/notes/shortnotes-and-material/single-revisions-material" && link === "/student/notes")
            return "nav-link active";

        else if (this.props.history.location.pathname === "/student/notes/practice-questions" && link === "/student/notes")
            return "nav-link active";

        else if (this.props.history.location.pathname === "/student/notes/exam-questions" && link === "/student/notes")
            return "nav-link active";

        else if (this.props.history.location.pathname === "/student/revision-material-groups/custom-revision-materials" && link === "/student/revision-material-groups")
            return "nav-link active";

        else if (this.props.history.location.pathname === "/student/revision-material-groups/custom-single-revision-material" && link === "/student/revision-material-groups")
            return "nav-link active";

        else if (this.props.history.location.pathname === "/student/exams/custom-practise-exam" && link === "/student/exams/custom-practise-exam")
            return "nav-link active";

        else if (this.props.history.location.pathname === "/student/student-blog/student-blog-view" && link === "/student/student-blog")
            return "nav-link active";

        else if (this.props.history.location.pathname === "/student/featuredvideos" && link === "/student/featuredvideos")
            return "nav-link active";
        else if (this.props.history.location.pathname === "/student/createpreviouspaperexam" && link === "/student/createpreviouspaperexam")
            return "nav-link active";
        else if (this.props.history.location.pathname === "/student/category_wise_videos" && link === "/student/category_wise_videos")
            return "nav-link active";
        else if (this.props.history.location.pathname === "/student/Neet_Rise_Course" && link === "/student/Neet_Rise_Course")
            return "nav-link active";
        else if (this.props.history.location.pathname === "/student/subPlans" && link === "/student/subPlans")
            return "nav-link active";
        else if (this.props.history.location.pathname === "/student/cbse" && link === "/student/cbse")
            return "nav-link active";
        else if (this.props.history.location.pathname === "/student/Neet_Rise_Course/liveClass_sessions" && link === "/student/Neet_Rise_Course")
            return "nav-link active";
        else if (this.props.history.location.pathname === "/student/Neet_Rise_Course/exams" && link === "/student/Neet_Rise_Course")
            return "nav-link active";
        else if (this.props.history.location.pathname === "/student/IpeClasses" && link === "/student/IpeClasses")
            return "nav-link active";
        else if (this.props.history.location.pathname === "/student/Neet_Crash_Course" && link === "/student/Neet_Crash_Course")
            return "nav-link active";
        else if (this.props.history.location.pathname === "/student/Neet_Crash_Course/liveClass_sessions" && link === "/student/Neet_Crash_Course")
            return "nav-link active";
        else if (this.props.history.location.pathname === "/student/live_Test_series/exams" && link === "/student/live_Test_series/exams")
            return "nav-link active";
        else if (this.props.history.location.pathname === "/student/practise_test" && link === "/student/practise_test")
            return "nav-link active";
        else if (this.props.history.location.pathname === "/student/StateShortNotes" && link === "/student/chapter-learning")
            return "nav-link active";
        else if (this.props.history.location.pathname === "/student/FormulaeSheets" && link === "/student/chapter-learning")
            return "nav-link active";
        else if (this.props.history.location.pathname === "/student/Mocktests" && link === "/student/Mocktests")
            return "nav-link active";
        else if (this.props.history.location.pathname === "/student/eamcet-crashcourse" && link === "/student/eamcet-crashcourse")
            return "nav-link active";
        else if (this.props.history.location.pathname === "/student/eamcet-crashcourse/liveclasses" && link === "/student/eamcet-crashcourse")
            return "nav-link active";
        else if (this.props.history.location.pathname === "/student/eamcet-crashcourse/exams" && link === "/student/eamcet-crashcourse")
            return "nav-link active";
        else if (this.props.history.location.pathname === "/student/StatePreviousPapers" && link === "/student/StatePreviousPapers")
            return "nav-link active";
        else if (this.props.history.location.pathname === "/student/plans_section" && link === "/student/plans_section")
            return "nav-link active";
        else if (this.props.history.location.pathname === "/student/StateBluePrint" && link === "/student/chapter-learning")
            return "nav-link active";
        else if (this.props.history.location.pathname === "/student/college-rank-predictor" && link === "/student/college-rank-predictor")
            return "nav-link active";
        else if (this.props.history.location.pathname === "/student/foundation-course/home" && link === "/student/foundation-course/home")
            return "nav-link active";
        else if (this.props.history.location.pathname === "/student/eamcet-longterm-course" && link === "/student/eamcet-longterm-course")
            return "nav-link active";
        else if (this.props.history.location.pathname === "/student/eamcet-longterm-course/liveclasses" && link === "/student/eamcet-longterm-course")
            return "nav-link active";
        else if (this.props.history.location.pathname === "/student/eamcet-longterm-course/exams" && link === "/student/eamcet-longterm-course")
            return "nav-link active";
        else if (this.props.history.location.pathname === "/student/ready-to-foundation-tests" && link === "/student/ready-to-foundation-tests")
            return "nav-link active";
        else if (this.props.history.location.pathname === "/student/Rizee-partner-offers" && link === "/student/Rizee-partner-offers")
            return "nav-link active";
        else if (this.props.history.location.pathname === "/student/NTA-College_predictor" && link === "/student/NTA-College_predictor")
            return "nav-link active";
        else if (this.props.history.location.pathname === "/student/Chapter-wise-questions" && link === "/student/chapter-learning")
            return "nav-link active";
        else if (this.props.history.location.pathname === "/student/Ipe-question-papers" && link === "/student/Ipe-question-papers")
            return "nav-link active";
        else if (this.props.history.location.pathname === "/student/Eamcet-Video-classes" && link === "/student/Eamcet-Video-classes")
            return "nav-link active";
        else if (this.props.history.location.pathname === "/student/institute-revison-materials" && link === "/student/institute-revison-materials")
            return "nav-link active";
        else if (this.props.history.location.pathname === "/student/ai" && link === "/student/ai")
            return "nav-link active";
        else if (this.props.history.location.pathname === "/student/chapter-wise-practise" && link === "/student/chapter-wise-practise")
            return "nav-link active";
        else
            return "nav-link";
    }

    forumLink = () => {
        const title = GoogleAnalyticsArray[0].Doubts_App;
        ReactGA.pageview(Cookies.get("forumlink"), ["rizee"], title);

        window.open(Cookies.get("forumlink"), "_blank")
    }
    render() {
        const getCrossSellingEnabled = this.props.getCrossSellingEnabled;
        const loading = getCrossSellingEnabled.loading;
        const error = getCrossSellingEnabled.error;



        let data = {};

        if (!loading) {
            data = getCrossSellingEnabled.getCrossSellingEnabled;
        }

        this.state.targetPopupData = data;



        let isStudentUserValid = "";
        if (JSON.parse(localStorage.getItem("isStudentUserValid")) != "") {
            isStudentUserValid = JSON.parse(localStorage.getItem("isStudentUserValid"));
        }
        else {
            this.props.history.push("/student/login");
        }
        const isuserValid = JSON.parse(
            isStudentUserValid.user_access_restictions
        );

        let partnerAccess = false;

        if (isuserValid.referred_mobile == "gsl635") {
            partnerAccess = true
        }


        return (
            <React.Fragment>
                <div className="sidebar-header mb-0 px-2 py-2" style={{ display: "flex", justifyContent: "center" }}>
                    {
                        Cookies.get("institution_id") == 119 ? (
                            <Link
                                to="/student/home"
                                className={this.getActiveClass("/student/home")}>
                                <Image className="logo" src={vignanLogo} width="150" style={{ margin: "auto" }} alt="Vignan" />
                                <Image className="small_logo" src={vignanShortLogo} width="40" style={{ margin: "auto" }} alt="Vignan" />
                            </Link>
                        ) : partnerAccess == false ? (

                            <>
                                <Link
                                    to="/student/home"
                                    className={this.getActiveClass("/student/home")}>
                                    {/* <Image className="logo" src={logo} width="100" alt="Image" />
                                <Image className="small_logo" src={small_logo} width="40" style={{ marginLeft: -22 }} alt="Image" /> */}
                                    <BrandLogo width="159.501" fill="#ffffff" className="logo" />
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 97 69" width="40" className="small_logo" style={{ marginLeft: -6 }}>
                                        <g id="Layer">
                                            <path fill="#ffffff" d="M0.29 68.12L29.73 17.51L17.03 17.51L27.42 0L51.48 0L88.82 68.13L69.19 68.13L44.55 26.37L20.69 68.13L0.29 68.12Z" />
                                            <path fill="#f9c52d" d="M56.22 0L96.83 0L76.53 35.5L56.22 0Z" />
                                        </g>
                                    </svg>
                                </Link>
                            </>


                        ) : (
                            <>
                                <BrandLogo width="159.501" fill="#ffffff" className="logo" />
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 97 69" width="40" className="small_logo" style={{ marginLeft: -6 }}>
                                    <g id="Layer">
                                        <path fill="#ffffff" d="M0.29 68.12L29.73 17.51L17.03 17.51L27.42 0L51.48 0L88.82 68.13L69.19 68.13L44.55 26.37L20.69 68.13L0.29 68.12Z" />
                                        <path fill="#f9c52d" d="M56.22 0L96.83 0L76.53 35.5L56.22 0Z" />
                                    </g>
                                </svg>
                            </>
                        )
                    }
                </div>
                <Scrollbars style={{ height: '80vh' }}
                    renderThumbVertical={renderThumb}
                    autoHideTimeout={500}
                    autoHideDuration={200}>
                    {
                        Cookies.get("student_userlevel") != "1" && (Cookies.get("examid") == 3 || Cookies.get("examid") == 6 || Cookies.get("examid") == 7 || Cookies.get("examid") == 8 || Cookies.get("examid") == 9 || Cookies.get("examid") == 10 || Cookies.get("examid") == 11) ? (


                            partnerAccess == false ? (
                                <Nav className="navbar-nav menu_eamcet">
                                    <Accordion defaultActiveKey={this.getAccordianActive()}>
                                        <Nav.Item>
                                            <Link className={this.getActiveClass("/student/home")} to="/student/home" onClick={() => this.props.onClick()}>
                                                <Image src={HomeEamcet} className="ml-2" alt="New" width="15" height="15" /> <span>Home</span>
                                            </Link>
                                        </Nav.Item>
                                        {/* {
                                            this.props.isuserValid.Doubts_App == true ? 
                                            ("") 
                                            : 
                                            (
                                                <Nav.Item>
                                                    <Link className={this.getActiveClass("/student/doubts")} to="/student/doubts" onClick={() => this.props.onClick()}>
                                                        <i className="fal fa-question-circle ml-2" style={{ fontSize: "15px" }} /> <span style={{ marginLeft: "5px" }}>Doubts</span>
                                                    </Link>
                                                </Nav.Item>
                                            )
                                        } */}
                                        {
                                            Cookies.get("student_userlevel") != "1" ?
                                                (
                                                    this.props.isuserValid.rizee_partnership == true ?
                                                        ("")
                                                        :
                                                        (
                                                            <Nav.Item>
                                                                <Link className={this.getActiveClass("/student/Rizee-partner-offers")} to="/student/Rizee-partner-offers" >
                                                                    <Image src={partnerOffers} className="ml-2" alt="New" width="15" height="15" /> <span>Partner Offers</span>
                                                                </Link>
                                                            </Nav.Item>
                                                        )
                                                )
                                                :
                                                ("")
                                        }
                                        {/* {
                                            Cookies.get("examid") == 3 || Cookies.get("examid") == 6 || Cookies.get("examid") == 7 || Cookies.get("examid") == 8 ?
                                                (
                                                    Cookies.get("student_userlevel") != "1" ? (
                                                        this.props.isuserValid.EAMCET_LongTerm == true ? ("") : (
                                                            <Nav.Item>
                                                                <Link className={this.getActiveClass("/student/eamcet-longterm-course/home")} to="/student/eamcet-longterm-course/home" onClick={() => this.props.onClick()}>
                                                                    <Image src={longtermCourse} className="ml-2" alt="New" width="15" height="15" /> <span>Long Term Course <Image src={gifImage} className="ml-1" alt="New" width="35" /></span>
                                                                </Link>
                                                            </Nav.Item>

                                                        )
                                                    ) : (
                                                        this.props.isuserValid.EAMCET_LongTerm == true ? ("") : (

                                                            <Nav.Item>
                                                                <Link className={this.getActiveClass("/student/eamcet-longterm-course/home")} to="/student/eamcet-longterm-course/home" onClick={() => this.props.onClick()}>
                                                                    <Image src={longtermCourse} className="ml-2" alt="New" width="15" height="15" /> <span>Long Term Course <Image src={gifImage} className="ml-1" alt="New" width="35" /></span>
                                                                </Link>
                                                            </Nav.Item>

                                                        )
                                                    )
                                                )
                                                :
                                                ("")
                                        } */}

                                        {/* IIT Foundation entitlement. isuserValid comes from
                                            user_access_restictions, so the flag being true means RESTRICTED -
                                            same polarity as the Foundation Course item below. */}
                                        {this.props.isuserValid.FoundationCourse == true ? ("") : (
                                          <>
                                          <Nav.Item>
                                              <Link
                                                  className={this.getActiveClass(
                                                      "/iit-foundation/student-dashboard",
                                                  )}
                                                  to="/iit-foundation/student-dashboard"
                                                  onClick={() => this.props.onClick()}
                                              >
                                                  <Image
                                                      src={CrashCourse}
                                                      className="ml-2"
                                                      alt="New"
                                                      width="15"
                                                      height="15"
                                                  />
                                                  <span>IIT FOUNDATION</span>
                                              </Link>
                                          </Nav.Item>

                                          {/* IIT Foundation Short Notes — shown to every student, no conditions */}
                                          <Nav.Item>
                                            <Link
                                              className={this.getActiveClass("/iit-foundation/short-notes")}
                                              to="/iit-foundation/short-notes"
                                              onClick={() => this.props.onClick()}
                                            >
                                              <Image
                                                src={ShortNotes}
                                                className="ml-2"
                                                alt="Short Notes"
                                                width="15"
                                                height="15"
                                              />
                                              <span>Short Notes</span>
                                            </Link>
                                          </Nav.Item>
                                          </>
                                        )}

                                        {
                                            Cookies.get("toggle") == "wrapper sidebar-enable" && Cookies.get("student_userlevel") == 2 && (Cookies.get("examid") == 3 || Cookies.get("examid") == 6 || Cookies.get("examid") == 7 || Cookies.get("examid") == 8) ?
                                                (<h6 className='nav_type_header'>ADMISSION</h6>)
                                                :
                                                ("")
                                        }
                                        {
                                            Cookies.get("student_userlevel") != "1" ? (
                                                Cookies.get("examid") == 3 || Cookies.get("examid") == 6 ?
                                                    (
                                                        <Nav.Item>
                                                            <Link className={this.getActiveClass("/student/college-rank-predictor")} to="/student/college-rank-predictor" onClick={() => this.props.onClick()}>
                                                                <Image src={Quiz} className="ml-1" alt="New" width="15" height="15" /> <span>College & Branch Predictor<Image src={gifImage} className="ml-1" alt="New" width="35" /></span>
                                                            </Link>
                                                        </Nav.Item>
                                                    ) :
                                                    ("")

                                            ) : (
                                                this.props.isuserValid.college_branch_predi == true ? ("") : (

                                                    <Nav.Item>
                                                        <Link className={this.getActiveClass("/student/college-rank-predictor")} to="/student/college-rank-predictor" onClick={() => this.props.onClick()}>
                                                            <Image src={Quiz} className="ml-1" alt="New" width="15" height="15" /> <span>College & Branch Predictor<Image src={gifImage} className="ml-1" alt="New" width="35" /></span>
                                                        </Link>
                                                    </Nav.Item>
                                                )
                                            )
                                        }


                                        {
                                            Cookies.get("examid") == "3" || Cookies.get("examid") == 6 || Cookies.get("examid") == 7 || Cookies.get("examid") == 8 ?
                                                (
                                                    Cookies.get("student_userlevel") != "1" ? (
                                                        this.props.isuserValid.ST_RankPredictor == true ? ("") : (
                                                            <Nav.Item>
                                                                <Link className={this.getActiveClass("/student/eamcet-rankPredictor")} to="/student/eamcet-rankPredictor" onClick={() => this.props.onClick()}>
                                                                    <Image src={RankPredictor} className="ml-2" alt="New" width="15" height="15" /><span>Rank Predictor</span>
                                                                </Link>
                                                            </Nav.Item>
                                                        )
                                                    ) : (
                                                        this.props.isuserValid.ST_RankPredictor == true ? ("") : (

                                                            <Nav.Item>
                                                                <Link className={this.getActiveClass("/student/eamcet-rankPredictor")} to="/student/eamcet-rankPredictor" onClick={() => this.props.onClick()}>
                                                                    <Image src={RankPredictor} className="ml-2" alt="New" width="15" height="15" /><span>Rank Predictor</span>
                                                                </Link>
                                                            </Nav.Item>
                                                        )
                                                    )
                                                )
                                                :
                                                ("")
                                        }



                                        {
                                            Cookies.get("toggle") == "wrapper sidebar-enable" && Cookies.get("student_userlevel") == 2 && (Cookies.get("examid") == 3 || Cookies.get("examid") == 6 || Cookies.get("examid") == 7 || Cookies.get("examid") == 8) ?
                                                (<h6 className='nav_type_header'>FOUNDATION</h6>)
                                                :
                                                ("")
                                        }
                                        {
                                            Cookies.get("examid") == 3 || Cookies.get("examid") == 6 || Cookies.get("examid") == 7 || Cookies.get("examid") == 8 ?
                                                (
                                                    Cookies.get("student_userlevel") != "1" ? (
                                                        this.props.isuserValid.FoundationCourse == true ? ("") : (
                                                            <Nav.Item>
                                                                <Link className={this.getActiveClass("/student/foundation-course/home")} to="/student/foundation-course/home" onClick={() => this.props.onClick()}>
                                                                    <Image src={foundationNavIcon} className="ml-2" alt="New" width="12" height="17" /><span>Foundation Course <Image src={gifImage} className="ml-1" alt="New" width="35" /></span>
                                                                </Link>
                                                            </Nav.Item>
                                                        )
                                                    ) : (
                                                        this.props.isuserValid.FoundationCourse == true ? ("") : (

                                                            <Nav.Item>
                                                                <Link className={this.getActiveClass("/student/foundation-course/home")} to="/student/foundation-course/home" onClick={() => this.props.onClick()}>
                                                                    <Image src={foundationNavIcon} className="ml-2" alt="New" width="12" height="17" /><span>Foundation Course <Image src={gifImage} className="ml-1" alt="New" width="35" /></span>
                                                                </Link>
                                                            </Nav.Item>
                                                        )
                                                    )
                                                )
                                                :
                                                ("")


                                        }

                                        {
                                            Cookies.get("examid") == 3 || Cookies.get("examid") == 6 || Cookies.get("examid") == 7 || Cookies.get("examid") == 8 ?
                                                (
                                                    Cookies.get("student_userlevel") != "1" ? (
                                                        this.props.isuserValid.Free_FoundationTests == true ? ("") : (
                                                            <Nav.Item>
                                                                <Link className={this.getActiveClass("/student/ready-to-foundation-tests")} to="/student/ready-to-foundation-tests" onClick={() => this.props.onClick()}>
                                                                    <Image src={foundationtest} className="ml-2" alt="New" width="15" height="15" /><span>Free Foundation Tests <Image src={gifImage} className="ml-1" alt="New" width="35" /></span>
                                                                </Link>
                                                            </Nav.Item>

                                                        )
                                                    ) : (
                                                        this.props.isuserValid.Free_FoundationTests == true ? ("") : (

                                                            <Nav.Item>
                                                                <Link className={this.getActiveClass("/student/ready-to-foundation-tests")} to="/student/ready-to-foundation-tests" onClick={() => this.props.onClick()}>
                                                                    <Image src={foundationtest} className="ml-2" alt="New" width="15" height="15" /><span>Free Foundation Tests <Image src={gifImage} className="ml-1" alt="New" width="35" /></span>
                                                                </Link>
                                                            </Nav.Item>

                                                        )
                                                    )
                                                )
                                                :
                                                ("")
                                        }
                                        {Cookies.get("examid") == 9 || Cookies.get("examid") == 10 || Cookies.get("examid") == 11 ? (<Nav.Item>
                                            <Link className={this.getActiveClass("/student/short-notes")} to="/student/short-notes">
                                                <Image src={ShortNotes} className="ml-2" alt="New" width="15" height="15" /> <span>Short Notes</span>
                                            </Link>
                                        </Nav.Item>) : ("")}

                                        {
                                            Cookies.get("examid") == 9 || Cookies.get("examid") == 10 || Cookies.get("examid") == 11 ?
                                                (
                                                    this.props.isuserValid.ins_revision_material_tab == true ? ("") : (<Nav.Item>
                                                        <Link className={this.getActiveClass("/student/revision-material-groups")} to="/student/revision-material-groups">
                                                            <i className="fal fa-books" title="Revision Materials" /> <span>Revision Material</span>
                                                        </Link>
                                                    </Nav.Item>)
                                                )
                                                :
                                                ("")
                                        }


                                        {
                                            Cookies.get("student_userlevel") == 1 ? (
                                                this.props.isuserValid.Custom_Materials == true ? ("") : (<Nav.Item>
                                                    <Link className={this.getActiveClass("/student/institute-revison-materials")} to="/student/institute-revison-materials">
                                                        <i className="fal fa-books" title="Revision Materials" /> <span>Custom Revision Material</span>
                                                    </Link>
                                                </Nav.Item>)
                                            ) : ("")
                                        }


                                        {
                                            Cookies.get("toggle") == "wrapper sidebar-enable" && Cookies.get("student_userlevel") == 2 && (Cookies.get("examid") == 3 || Cookies.get("examid") == 6 || Cookies.get("examid") == 7 || Cookies.get("examid") == 8) ?
                                                (<h6 className='nav_type_header'>TEST PREP BUNDLE</h6>)
                                                :
                                                ("")
                                        }
                                        {
                                            Cookies.get("student_userlevel") != "1" ? (
                                                this.props.isuserValid.ST_PreviousTests == true ? ("") : (
                                                    <Nav.Item>
                                                        <Link className={this.getActiveClass("/student/StatePreviousPapers")} to="/student/StatePreviousPapers" onClick={() => this.props.onClick()}>
                                                            <Image src={EamcetPrevious} className="ml-2" alt="New" width="15" height="15" /> <span>Previous Tests</span>
                                                        </Link>
                                                    </Nav.Item>
                                                )
                                            ) : (
                                                this.props.isuserValid.ST_PreviousTests == true ? ("") : (

                                                    <Nav.Item>
                                                        <Link className={this.getActiveClass("/student/StatePreviousPapers")} to="/student/StatePreviousPapers" onClick={() => this.props.onClick()}>
                                                            <Image src={EamcetPrevious} className="ml-2" alt="New" width="15" height="15" /> <span>Previous Tests</span>
                                                        </Link>
                                                    </Nav.Item>)
                                            )}
                                        {
                                            Cookies.get("student_userlevel") != "1" ? (
                                                this.props.isuserValid.ST_MockTests == true ? ("") : (
                                                    <Nav.Item>

                                                        <Link className={this.getActiveClass("/student/Mocktests")} to="/student/Mocktests" onClick={() => this.props.onClick()}>
                                                            <Image src={MockTest} className="ml-2" alt="New" width="15" height="15" /> <span>Mock Tests</span>
                                                        </Link>

                                                    </Nav.Item>
                                                )
                                            ) : (
                                                this.props.isuserValid.ST_MockTests == true ? ("") : (

                                                    <Nav.Item>

                                                        <Link className={this.getActiveClass("/student/Mocktests")} to="/student/Mocktests" onClick={() => this.props.onClick()}>
                                                            <Image src={MockTest} className="ml-2" alt="New" width="15" height="15" /> <span>Mock Tests</span>
                                                        </Link>

                                                    </Nav.Item>
                                                )
                                            )}
                                        {
                                            Cookies.get("student_userlevel") != "1" ? (
                                                this.props.isuserValid.ST_Practice == true ? ("") : (
                                                    <Nav.Item>
                                                        <Link className={this.getActiveClass("/student/practise_test")} to="/student/practise_test" onClick={() => this.props.onClick()}>
                                                            <Image src={PractiseTest} className="ml-2" alt="New" width="15" height="15" /> <span>Practice Sessions</span>
                                                        </Link>
                                                    </Nav.Item>
                                                )
                                            ) : (
                                                this.props.isuserValid.ST_Practice == true ? ("") : (
                                                    <Nav.Item>
                                                        <Link className={this.getActiveClass("/student/practise_test")} to="/student/practise_test" onClick={() => this.props.onClick()}>
                                                            <Image src={PractiseTest} className="ml-2" alt="New" width="15" height="15" /> <span>Practice Sessions</span>
                                                        </Link>
                                                    </Nav.Item>
                                                )
                                            )
                                        }
                                        {
                                            Cookies.get("student_userlevel") != "1" ?
                                                (
                                                    this.props.isuserValid.ST_Error_Exam == true ? ("") :
                                                        (
                                                            <Nav.Item>
                                                                <Link className={this.getActiveClass("/student/error_exam")} to="/student/error_exam" onClick={() => this.props.onClick()} >
                                                                    <Image src={CrashCourse} className="ml-2" alt="New" width="15" height="15" /><span>Error Exam <Image src={gifImage} className="ml-1" alt="New" width="35" /></span>
                                                                </Link>
                                                            </Nav.Item>
                                                        )
                                                )
                                                :
                                                (
                                                    this.props.isuserValid.ST_Error_Exam == true ? ("") :
                                                        (
                                                            <Nav.Item>
                                                                <Link className={this.getActiveClass("/student/error_exam")} to="/student/error_exam" onClick={() => this.props.onClick()} >
                                                                    <Image src={CrashCourse} className="ml-2" alt="New" width="15" height="15" /><span>Error Exam <Image src={gifImage} className="ml-1" alt="New" width="35" /></span>
                                                                </Link>
                                                            </Nav.Item>
                                                        )
                                                )
                                        }

                                        {
                                            Cookies.get("student_userlevel") != "1" ?
                                                (
                                                    this.props.isuserValid.ST_Performance == true ? ("") :
                                                        (
                                                            <Nav.Item>
                                                                <Link className={this.getActiveClass("/student/performance-analysis")} to="/student/performance-analysis" onClick={() => this.props.onClick()} >
                                                                    <Image src={CrashCourse} className="ml-2" alt="New" width="15" height="15" /><span>Performace Analysis <Image src={gifImage} className="ml-1" alt="New" width="35" /></span>
                                                                </Link>
                                                            </Nav.Item>
                                                        )
                                                )
                                                :
                                                (
                                                    this.props.isuserValid.ST_Performance == true ? ("") :
                                                        (
                                                            <Nav.Item>
                                                                <Link className={this.getActiveClass("/student/performance-analysis")} to="/student/performance-analysis" onClick={() => this.props.onClick()} >
                                                                    <Image src={CrashCourse} className="ml-2" alt="New" width="15" height="15" /><span>Performace Analysis <Image src={gifImage} className="ml-1" alt="New" width="35" /></span>
                                                                </Link>
                                                            </Nav.Item>
                                                        )
                                                )
                                        }

                                        {
                                            Cookies.get("toggle") == "wrapper sidebar-enable" && Cookies.get("student_userlevel") == 2 && (Cookies.get("examid") == 3 || Cookies.get("examid") == 6 || Cookies.get("examid") == 7 || Cookies.get("examid") == 8) ?
                                                (<h6 className='nav_type_header'>PREPARATION</h6>)
                                                :
                                                ("")
                                        }


                                        {this.hasChapterWiseLearningItems() ? (
                                        <React.Fragment>
                                            <Accordion.Toggle as={Nav.Item} eventKey={2} className="HasChild">
                                                <a className={this.getActiveClass("/student/chapter-learning")}
                                                >
                                                    <i className="fal fa-cogs" title="Learning Tools" /> <span>Chapter wise Learning</span>
                                                </a>
                                            </Accordion.Toggle>
                                            <Accordion.Collapse eventKey={2}>
                                                <div className="collapse-inner">
                                                    {
                                                        Cookies.get("examid") == 3 || Cookies.get("examid") == 6 || Cookies.get("examid") == 7 || Cookies.get("examid") == 8 ?
                                                            (
                                                                Cookies.get("student_userlevel") != "1" ?
                                                                    (
                                                                        this.props.isuserValid.Chapterpreviousquestions == true ? ("")
                                                                            :
                                                                            (
                                                                                <Nav.Item>
                                                                                    <Link className={this.getActiveClassTwo("/student/Chapter-wise-questions")} to="/student/Chapter-wise-questions" >
                                                                                        <Image src={PractiseTest} className="ml-2" alt="New" width="15" height="15" /> <span>Previous Paper Questions</span>
                                                                                    </Link>
                                                                                </Nav.Item>
                                                                            )
                                                                    )
                                                                    :
                                                                    (
                                                                        this.props.isuserValid.Chapterpreviousquestions == true ? ("") : (
                                                                            <Nav.Item>
                                                                                <Link className={this.getActiveClassTwo("/student/Chapter-wise-questions")} to="/student/Chapter-wise-questions" >
                                                                                    <Image src={PractiseTest} className="ml-2" alt="New" width="15" height="15" /> <span>Previous Paper Questions</span>
                                                                                </Link>
                                                                            </Nav.Item>
                                                                        )
                                                                    )
                                                            )
                                                            :
                                                            ("")
                                                    }

                                                    {
                                                        Cookies.get("examid") == 3 || Cookies.get("examid") == 6 || Cookies.get("examid") == 7 || Cookies.get("examid") == 8 ?
                                                            (
                                                                Cookies.get("student_userlevel") != "1" ? (
                                                                    this.props.isuserValid.ST_ShortNotes == true ? ("") : (
                                                                        <Nav.Item>
                                                                            <Link className={this.getActiveClassTwo("/student/StateShortNotes")} to="/student/StateShortNotes" onClick={() => this.props.onClick()}>
                                                                                <Image src={ShortNotes} className="ml-2" alt="New" width="15" height="15" /> <span>Short Notes</span>
                                                                            </Link>
                                                                        </Nav.Item>
                                                                    )
                                                                ) : (
                                                                    this.props.isuserValid.ST_ShortNotes == true ? ("") : (
                                                                        <Nav.Item>
                                                                            <Link className={this.getActiveClassTwo("/student/StateShortNotes")} to="/student/StateShortNotes" onClick={() => this.props.onClick()}>
                                                                                <Image src={ShortNotes} className="ml-2" alt="New" width="15" height="15" /> <span>Short Notes</span>
                                                                            </Link>
                                                                        </Nav.Item>
                                                                    )
                                                                )
                                                            )
                                                            :
                                                            ("")
                                                    }

                                                    {
                                                        Cookies.get("examid") == 3 || Cookies.get("examid") == 6 || Cookies.get("examid") == 7 || Cookies.get("examid") == 8 ?
                                                            (
                                                                Cookies.get("student_userlevel") != "1" ? (
                                                                    this.props.isuserValid.ST_RevisionMaterial == true ? ("") : (
                                                                        <Nav.Item>
                                                                            <Link className={this.getActiveClassTwo("/student/FormulaeSheets")} to="/student/FormulaeSheets" onClick={() => this.props.onClick()}>
                                                                                <Image src={Formulas} className="ml-2" alt="New" width="15" height="15" /> <span>Revision Material</span>
                                                                            </Link>
                                                                        </Nav.Item>
                                                                    )
                                                                ) : (
                                                                    this.props.isuserValid.ST_RevisionMaterial == true ? ("") : (
                                                                        <Nav.Item>
                                                                            <Link className={this.getActiveClassTwo("/student/FormulaeSheets")} to="/student/FormulaeSheets" onClick={() => this.props.onClick()}>
                                                                                <Image src={Formulas} className="ml-2" alt="New" width="15" height="15" /> <span>Revision Material</span>
                                                                            </Link>
                                                                        </Nav.Item>
                                                                    )
                                                                )
                                                            )
                                                            :
                                                            ("")
                                                    }
                                                    {
                                                        Cookies.get("examid") == 3 || Cookies.get("examid") == 6 || Cookies.get("examid") == 7 || Cookies.get("examid") == 8 ?
                                                            (
                                                                Cookies.get("student_userlevel") != "1" ? (
                                                                    this.props.isuserValid.ChapterVideos == true ? ("") : (
                                                                        <Nav.Item>
                                                                            <Link className={this.getActiveClassTwo("/student/Eamcet-Video-classes")} to="/student/Eamcet-Video-classes" >
                                                                                <i className="fal fa-video" title="Videos" /> <span>Video Classes</span>
                                                                            </Link>
                                                                        </Nav.Item>
                                                                    )
                                                                ) : (
                                                                    this.props.isuserValid.ChapterVideos == true ? ("") : (
                                                                        <Nav.Item>
                                                                            <Link className={this.getActiveClassTwo("/student/Eamcet-Video-classes")} to="/student/Eamcet-Video-classes" >
                                                                                <i className="fal fa-video" title="Videos" /> <span>Video Classes</span>
                                                                            </Link>
                                                                        </Nav.Item>
                                                                    )
                                                                )
                                                            )
                                                            :
                                                            ("")
                                                    }
                                                    {
                                                        Cookies.get("student_userlevel") != "1" ? (
                                                            this.props.isuserValid.ST_BluePrint == true ? ("") : (
                                                                <Nav.Item>
                                                                    <Link className={this.getActiveClassTwo("/student/StateBluePrint")} to="/student/StateBluePrint" onClick={() => this.props.onClick()}>
                                                                        <Image src={BluePrint} className="ml-2" alt="New" width="15" height="15" /> <span>Blue Print</span>
                                                                    </Link>
                                                                </Nav.Item>
                                                            )
                                                        ) : (
                                                            this.props.isuserValid.ST_BluePrint == true ? ("") : (

                                                                <Nav.Item>
                                                                    <Link className={this.getActiveClassTwo("/student/StateBluePrint")} to="/student/StateBluePrint" onClick={() => this.props.onClick()}>
                                                                        <Image src={BluePrint} className="ml-2" alt="New" width="15" height="15" /> <span>Blue Print</span>
                                                                    </Link>
                                                                </Nav.Item>
                                                            )
                                                        )
                                                    }
                                                </div>
                                            </Accordion.Collapse>
                                        </React.Fragment>
                                        ) : ("")}
                                        {
                                            Cookies.get("examid") == 3 || Cookies.get("examid") == 6 || Cookies.get("examid") == 7 || Cookies.get("examid") == 8 ?
                                                (
                                                    Cookies.get("student_userlevel") != "1" ? (
                                                        this.props.isuserValid.IPEpapers == true ?
                                                            ("")
                                                            :
                                                            (
                                                                <Nav.Item>
                                                                    <Link className={this.getActiveClass("/student/Ipe-question-papers")} to="/student/Ipe-question-papers" >
                                                                        <Image src={EamcetPrevious} className="ml-2" alt="New" width="15" height="15" /> <span>IPE Previous Papers <Image src={gifImage} className="ml-1" alt="New" width="35" /></span>
                                                                    </Link>
                                                                </Nav.Item>

                                                            )
                                                    ) : (
                                                        this.props.isuserValid.IPEpapers == true ? ("") : (

                                                            <Nav.Item>
                                                                <Link className={this.getActiveClass("/student/Ipe-question-papers")} to="/student/Ipe-question-papers" >
                                                                    <Image src={EamcetPrevious} className="ml-2" alt="New" width="15" height="15" /> <span>IPE Previous Papers <Image src={gifImage} className="ml-1" alt="New" width="35" /></span>
                                                                </Link>
                                                            </Nav.Item>

                                                        )
                                                    )
                                                )
                                                :
                                                ("")
                                        }


                                        {
                                            Cookies.get("examid") == 3 || Cookies.get("examid") == 6 || Cookies.get("examid") == 7 || Cookies.get("examid") == 8 ?
                                                (
                                                    Cookies.get("student_userlevel") == "1" ? (
                                                        this.props.isuserValid.ST_IPELectures2022 == true ? ("") : (
                                                            <Nav.Item>
                                                                <Link className={this.getActiveClass("/student/IpeClasses")} to="/student/IpeClasses" onClick={() => this.props.onClick()}>
                                                                    <Image src={IpeLectures} className="ml-2" alt="New" width="15" height="15" /> <span>IPE Lectures</span>
                                                                </Link>
                                                            </Nav.Item>
                                                        )

                                                    ) : (
                                                        this.props.isuserValid.ST_IPELectures2022 == true ? ("") : (
                                                            <Nav.Item>
                                                                <Link className={this.getActiveClass("/student/IpeClasses")} to="/student/IpeClasses" onClick={() => this.props.onClick()}>
                                                                    <Image src={IpeLectures} className="ml-2" alt="New" width="15" height="15" /> <span>IPE Lectures</span>
                                                                </Link>
                                                            </Nav.Item>
                                                        )
                                                    )
                                                )
                                                :
                                                ("")

                                        }
                                        {
                                            Cookies.get("student_userlevel") != "1" ? (
                                                this.props.isuserValid.ST_Quiz == true ? ("") : (
                                                    <Nav.Item>
                                                        <Link className={this.getActiveClass("/student/exams/quiz_exam")} to="/student/exams/quiz_exam" onClick={() => this.props.onClick()}>
                                                            <Image src={Quiz} className="ml-2" alt="New" width="15" height="15" /> <span>Quiz</span>
                                                        </Link>
                                                    </Nav.Item>
                                                )
                                            ) : (
                                                this.props.isuserValid.ST_Quiz == true ? ("") : (

                                                    <Nav.Item>
                                                        <Link className={this.getActiveClass("/student/exams/quiz_exam")} to="/student/exams/quiz_exam" onClick={() => this.props.onClick()}>
                                                            <Image src={Quiz} className="ml-2" alt="New" width="15" height="15" /> <span>Quiz</span>
                                                        </Link>
                                                    </Nav.Item>
                                                )
                                            )}


                                        {
                                            Cookies.get("toggle") == "wrapper sidebar-enable" && Cookies.get("student_userlevel") == 2 && (Cookies.get("examid") == 3 || Cookies.get("examid") == 6 || Cookies.get("examid") == 7 || Cookies.get("examid") == 8) ?
                                                (<h6 className='nav_type_header'>OTHERS</h6>)
                                                :
                                                ("")
                                        }
                                        {/* 
                                        <Nav.Item>
                                            <Link className={this.getActiveClass("/student/doubts")} to="/student/doubts" onClick={() => this.props.onClick()}>
                                                <i className="fal fa-question-circle" title="Doubts" /> <span>Doubts</span>
                                            </Link>
                                        </Nav.Item> */}
                                        {
                                            Cookies.get("student_userlevel") != "1" ? (
                                                <Nav.Item>
                                                    <Link className={this.getActiveClass("/student/plans_section")} to="/student/plans_section" onClick={() => this.props.onClick()}>
                                                        <Image src={Subscriptions} className="ml-2" alt="New" width="15" height="15" /><span>Subscription Plans</span>
                                                    </Link>
                                                </Nav.Item>
                                            ) : ("")

                                        }
                                        {
                                            Cookies.get("student_userlevel") != "1" ?
                                                (
                                                    <Nav.Item>
                                                        <Link className={this.getActiveClass("/student/referFriend")} to="/student/referFriend" onClick={() => this.props.onClick()}>
                                                            <i className="fal fa-clipboard-list-check" title="Refer Friend" /> <span>Refer a Friend</span>
                                                        </Link>
                                                    </Nav.Item>
                                                )
                                                :
                                                ("")
                                        }
                                        {/* Blog hidden from the side menu
                                        {
                                            Cookies.get("student_userlevel") != "1" ? (
                                                this.props.isuserValid.ST_Blog == true ? ("") : (
                                                    <Nav.Item>
                                                        <Link className={this.getActiveClass("/student/student-blog")} to="/student/student-blog" onClick={() => this.props.onClick()}>
                                                            <Image src={BlogEamcet} className="ml-2" alt="New" width="15" height="15" /><span>Blog</span>
                                                        </Link>
                                                    </Nav.Item>
                                                )
                                            ) : (
                                                this.props.isuserValid.ST_Blog == true ? ("") : (
                                                    <Nav.Item>
                                                        <Link className={this.getActiveClass("/student/student-blog")} to="/student/student-blog" onClick={() => this.props.onClick()}>
                                                            <Image src={BlogEamcet} className="ml-2" alt="New" width="15" height="15" /><span>Blog</span>
                                                        </Link>
                                                    </Nav.Item>
                                                )
                                            )
                                        }
                                        */}

                                    </Accordion>
                                </Nav>
                            ) : (
                                <Nav className="navbar-nav menu_eamcet">
                                    <Accordion defaultActiveKey={this.getAccordianActive()}>
                                      {/* IIT FOUNDATION and Short Notes are deliberately NOT
                                          rendered in this branch. WebAsideNavbar's matching
                                          menu_eamcet nav renders "" here, so these two items
                                          showed on mobile only. See git history to restore. */}


                                        {
                                            Cookies.get("toggle") == "wrapper sidebar-enable" && Cookies.get("student_userlevel") == 2 ?
                                                (<h6 className='nav_type_header'>TEST PREP BUNDLE</h6>)
                                                :
                                                ("")
                                        }

                                        <Nav.Item>
                                            <Link className={this.getActiveClass("/student/StatePreviousPapers")} to="/student/StatePreviousPapers" onClick={() => this.props.onClick()}>
                                                <Image src={EamcetPrevious} className="ml-2" alt="New" width="15" height="15" /> <span>Previous Tests</span>
                                            </Link>
                                        </Nav.Item>


                                        <Nav.Item>

                                            <Link className={this.getActiveClass("/student/Mocktests")} to="/student/Mocktests" onClick={() => this.props.onClick()}>
                                                <Image src={MockTest} className="ml-2" alt="New" width="15" height="15" /> <span>Mock Tests</span>
                                            </Link>

                                        </Nav.Item>

                                        <Nav.Item>
                                            <Link className={this.getActiveClass("/student/practise_test")} to="/student/practise_test" onClick={() => this.props.onClick()}>
                                                <Image src={PractiseTest} className="ml-2" alt="New" width="15" height="15" /> <span>Practice Sessions</span>
                                            </Link>
                                        </Nav.Item>

                                        <Nav.Item>
                                            <Link className={this.getActiveClass("/student/error_exam")} to="/student/error_exam" onClick={() => this.props.onClick()} >
                                                <Image src={CrashCourse} className="ml-2" alt="New" width="15" height="15" /><span>Error Exam <Image src={gifImage} className="ml-1" alt="New" width="35" /></span>
                                            </Link>
                                        </Nav.Item>

                                        <Nav.Item>
                                            <Link className={this.getActiveClass("/student/performance-analysis")} to="/student/performance-analysis" onClick={() => this.props.onClick()} >
                                                <Image src={CrashCourse} className="ml-2" alt="New" width="15" height="15" /><span>Performace Analysis <Image src={gifImage} className="ml-1" alt="New" width="35" /></span>
                                            </Link>
                                        </Nav.Item>

                                    </Accordion>
                                </Nav>

                            )

                        ) : (
                            partnerAccess == false ? (
                                <Nav className="navbar-nav menu">
                                    <Accordion defaultActiveKey={this.getAccordianActive()}>
                                      {/* IIT FOUNDATION and Short Notes are not shown in this
                                          menu, same as WebAsideNavbar's matching "navbar-nav menu"
                                          (partnerAccess == false) branch, where both are commented
                                          out. They showed on mobile only. */}

                                        {Cookies.get("institution_id") == 119 ? ("") : (
                                            <Nav.Item>
                                                <Link className={this.getActiveClass("/student/home")} to="/student/home" onClick={() => this.props.onClick()}>
                                                    <i className="fal fa-home" title="Home" /> <span>Home</span>
                                                </Link>
                                            </Nav.Item>
                                        )}
                                        {/* {
                                            this.props.isuserValid.Doubts_App == true ? 
                                            ("") 
                                            : 
                                            (
                                                <Nav.Item>
                                                    <Link className={this.getActiveClass("/student/doubts")} to="/student/doubts" onClick={() => this.props.onClick()}>
                                                        <i className="fal fa-question-circle" title="Doubts" /> <span>Doubts</span>
                                                    </Link>
                                                </Nav.Item>
                                            )
                                        } */}

                                        {
                                            Cookies.get("mobile") == "9999999999" || Cookies.get("mobile") == "1111100026" || Cookies.get("mobile") == "1111100025" ? (
                                                <>
                                                    <Nav.Item>
                                                        <Link className={this.getActiveClass("/student/ai")} to="/student/ai">
                                                            <i className="fas fa-robot" /><span>Smart Study Tour</span>
                                                        </Link>
                                                    </Nav.Item>
                                                </>
                                            ) : ("")
                                        }


                                        {/* {
                                            Cookies.get("institution_id") == "100" ? (
                                                <>
                                                    <Nav.Item>
                                                        <Link className={this.getActiveClass("/student/chapter-wise-practise")} to="/student/chapter-wise-practise">
                                                            <i className="fas fa-book-open" /><span>chapter wise practise</span>
                                                        </Link>
                                                    </Nav.Item>
                                                </>
                                            ) : ("")
                                        } */}
                                        {/* {
                                        Cookies.get("examid") == 1  ?
                                            (
                                                this.isStudentUserValid.current_plan_id == 25 || this.isStudentUserValid.current_plan_id == 28 || this.isStudentUserValid.current_plan_id == 31 || this.isStudentUserValid.current_plan_id == 29 ?
                                                    (
                                                        <Nav.Item>
                                                            <Link className={this.getActiveClass("/student/Neet_Rise_Course")} to="/student/Neet_Rise_Course">
                                                                <i className="fas fa-book-open" title="NEET Rise Course" /> {Cookies.get("examid") == 1 ? (<><span>NEET Rise Course</span> <span className="label-bg">New</span></>) : (<span>JEE Repeaters</span>)}
                                                            </Link>
                                                        </Nav.Item>
                                                    )
                                                    :
                                                    (
                                                        <Nav.Item>
                                                            <Link className={this.getActiveClass("/student/Neet_Crash_Course")} to="/student/Neet_Crash_Course">
                                                                <i className="fas fa-book-open" title="NEET Crash Course" /> {Cookies.get("examid") == 1 ? (<><span>NEET 2023 Crash Course</span> <span className="label-bg">New</span></>) : (<span>JEE Repeaters</span>)}
                                                            </Link>
                                                        </Nav.Item>
                                                    )

                                            )
                                            :
                                            ("")
                                    } */}

                                        {
                                            Cookies.get("student_userlevel") != "1" ?
                                                (
                                                    this.props.isuserValid.rizee_partnership == true ?
                                                        ("")
                                                        :
                                                        (
                                                            <Nav.Item>
                                                                <Link className={this.getActiveClass("/student/Rizee-partner-offers")} to="/student/Rizee-partner-offers" >
                                                                    <Image src={partnerOffers} className="ml-2" alt="New" width="15" height="15" /> <span>Partner Offers</span>
                                                                </Link>
                                                            </Nav.Item>
                                                        )
                                                )
                                                :
                                                ("")
                                        }
                                        {
                                            Cookies.get("student_userlevel") == 1 ?
                                                (
                                                    <Nav.Item>
                                                        <Link className={this.getActiveClass("/student/exams/schedule-exam")} to="/student/exams/schedule-exam" onClick={() => this.props.onClick()}>
                                                            <Image src={CrashCourse} className="ml-2" alt="New" width="15" height="15" /><span>Schedule Exam</span>
                                                        </Link>
                                                    </Nav.Item>
                                                )
                                                :
                                                ("")
                                        }

                                        {
                                            Cookies.get("toggle") == "wrapper sidebar-enable" && Cookies.get("student_userlevel") == 2 ?
                                                (<h6 className='nav_type_header'>TEST PREP BUNDLE</h6>)
                                                :
                                                ("")
                                        }
                                        {this.props.isuserValid.userlevel == 1 ? (
                                            this.props.isuserValid.PreviousYearMockTest != true ? (
                                                <Nav.Item>
                                                    <Link className={this.getActiveClass("/student/previouspaperexams")} to="/student/previouspaperexams" onClick={() => this.props.onClick()}>
                                                        <i className="fal fa-clipboard-list-check" title="Previous papers" /> <span>Previous Year Papers</span>
                                                    </Link>
                                                </Nav.Item>
                                            ) : ("")
                                        ) : (
                                            <Nav.Item>
                                                <Link className={this.getActiveClass("/student/previouspaperexams")} to="/student/previouspaperexams" onClick={() => this.props.onClick()}>
                                                    <i className="fal fa-clipboard-list-check" title="Previous papers" /> <span>Previous Year Papers</span>
                                                </Link>
                                            </Nav.Item>
                                        )}
                                        {
                                            Cookies.get("examid") == 2 ? (
                                                this.props.isuserValid.ins_mock_test == true ? ("") : (<Nav.Item>

                                                    <Link className={this.getActiveClass("/student/exams/test-series")} to="/student/exams/test-series" onClick={() => this.props.onClick()}>
                                                        <i className="fal fa-badge-check" title="Exams History" /> <span>Mock Tests with Analysis</span>
                                                    </Link>

                                                </Nav.Item>)

                                            ) : ("")
                                        }
                                        {
                                            Cookies.get("examid") == 1 ? (
                                                this.props.isuserValid.userlevel == 1 ?
                                                    (
                                                        this.props.isuserValid.ins_mock_test_nta != true ?
                                                            (
                                                                <Nav.Item>
                                                                    <Link className={this.getActiveClass("/student/exams/test-series/NewNTAPattern")} to="/student/exams/test-series/NewNTAPattern" onClick={() => this.props.onClick()}>
                                                                        <i className="fal fa-clipboard-list-check" title="New NTA Pattern" /> <span>Mock Tests with Analysis</span>
                                                                    </Link>
                                                                </Nav.Item>
                                                            )
                                                            :
                                                            ("")
                                                    )
                                                    :
                                                    (
                                                        <Nav.Item>
                                                            <Link className={this.getActiveClass("/student/exams/test-series/NewNTAPattern")} to="/student/exams/test-series/NewNTAPattern" onClick={() => this.props.onClick()}>
                                                                <i className="fal fa-clipboard-list-check" title="New NTA Pattern" /> <span>Mock Tests with Analysis</span>
                                                            </Link>
                                                        </Nav.Item>
                                                    )
                                            ) : ("")

                                        }
                                        {this.props.isuserValid.error_exam == true ? ("") : (<Nav.Item>
                                            <Link className={this.getActiveClass("/student/exams/error-exam")} to="/student/exams/error-exam">
                                                <i className="fas fa-exclamation-circle" title="Error Exam" /> <span>Error Exam</span>
                                            </Link>
                                        </Nav.Item>)}

                                        {this.props.isuserValid.ins_analysis_tab == true ? ("") : (
                                            <Nav.Item>
                                                <Link className={this.getActiveClass("/student/result-analysis")} to="/student/result-analysis" onClick={() => this.props.onClick()}>
                                                    <i className="fal fa-analytics" title="Result &amp; Analysis" /><span>Performance Analysis</span>
                                                </Link>
                                            </Nav.Item>

                                        )}

                                        {/* {this.props.isuserValid.ins_analysis_tab == true ? ("") : (
                                            <Nav.Item>
                                                <Link className={this.getActiveClass("/student/performance-report")} to="/student/performance-report" onClick={() => this.props.onClick()}>
                                                    <i className="fas fa-chart-line" title="Result &amp; Report" /><span>Performance Report</span>
                                                </Link>
                                            </Nav.Item>
                                        )} */}

                                        {Cookies.get("institution_id") == 51 && (Cookies.get("examid") == 27 || Cookies.get("examid") == 28 || Cookies.get("examid") == 29) ? (
                                            <>
                                                <h6 className="nav_type_header group_type ">IIT FOUNDATION</h6>
                                                <Nav.Item>
                                                    <Link className={this.getActiveClass("/student/iit-foundation-course/videos")} to="/student/iit-foundation-course/videos" onClick={() => this.props.onClick()}>
                                                        <Image src={foundationNavIcon} className="ml-2" alt="New" width="12" height="17" /><span>Videos <Image src={gifImage} className="ml-1" alt="New" width="35" /></span>
                                                    </Link>
                                                </Nav.Item>
                                                <Nav.Item>
                                                    <Link className={this.getActiveClass("/student/iit-foundation-course/notes")} to="/student/iit-foundation-course/notes" onClick={() => this.props.onClick()}>
                                                        <Image src={foundationNavIcon} className="ml-2" alt="New" width="12" height="17" /><span>Notes <Image src={gifImage} className="ml-1" alt="New" width="35" /></span>
                                                    </Link>
                                                </Nav.Item>
                                                <Nav.Item>
                                                    <Link className={this.getActiveClass("/student/iit-foundation-course/tests")} to="/student/iit-foundation-course/tests" onClick={() => this.props.onClick()}>
                                                        <Image src={foundationNavIcon} className="ml-2" alt="New" width="12" height="17" /><span>Tests <Image src={gifImage} className="ml-1" alt="New" width="35" /></span>
                                                    </Link>
                                                </Nav.Item>
                                                <Nav.Item>
                                                    <Link className={this.getActiveClass("/student/iit-foundation-course/practice")} to="/student/iit-foundation-course/practice" onClick={() => this.props.onClick()}>
                                                        <Image src={foundationNavIcon} className="ml-2" alt="New" width="12" height="17" /><span>Practice <Image src={gifImage} className="ml-1" alt="New" width="35" /></span>
                                                    </Link>
                                                </Nav.Item>
                                                <Nav.Item>
                                                    <Link className={this.getActiveClass("/student/iit-foundation-course/analysis")} to="/student/iit-foundation-course/analysis" onClick={() => this.props.onClick()}>
                                                        <Image src={foundationNavIcon} className="ml-2" alt="New" width="12" height="17" /><span>Analysis <Image src={gifImage} className="ml-1" alt="New" width="35" /></span>
                                                    </Link>
                                                </Nav.Item>
                                                <Nav.Item>
                                                    <Link className={this.getActiveClass("/student/iit-foundation-course/error-exams")} to="/student/iit-foundation-course/videos" onClick={() => this.props.onClick()}>
                                                        <Image src={foundationNavIcon} className="ml-2" alt="New" width="12" height="17" /><span>Error Exams <Image src={gifImage} className="ml-1" alt="New" width="35" /></span>
                                                    </Link>
                                                </Nav.Item>
                                            </>
                                        ) : ("")}

                                        {
                                            Cookies.get("student_userlevel") == 1 ? (
                                                this.props.isuserValid.Custom_Materials == true ? ("") : (<Nav.Item>
                                                    <Link className={this.getActiveClass("/student/institute-revison-materials")} to="/student/institute-revison-materials">
                                                        <i className="fal fa-books" title="Revision Materials" /> <span>Custom Revision Material</span>
                                                    </Link>
                                                </Nav.Item>)
                                            ) : ("")
                                        }







                                        {/*this.props.isuserValid.ins_mock_test == true ? ("") : (<Nav.Item>

                                        <Link className={this.getActiveClass("/student/exams/test-series")} to="/student/exams/test-series" onClick={() => this.props.onClick()}>
                                            <i className="fal fa-badge-check" title="Exams History" /> <span>Mock Tests</span>
                                        </Link>

                                    </Nav.Item>)*/}

                                        {/* {
                                        Cookies.get("toggle") == "wrapper sidebar-enable" ?
                                            (<h6 className='nav_type_header'>FOUNDATION</h6>)
                                            :
                                            ("")
                                    }
                                    {
                                        Cookies.get("student_userlevel") != "1" ? (
                                            this.props.isuserValid.FoundationCourse == true ? ("") : (
                                                <Nav.Item>
                                                    <Link className={this.getActiveClass("/student/foundation-course/home")} to="/student/foundation-course/home" onClick={() => this.props.onClick()}>
                                                        <Image src={foundationNavIcon} className="ml-2" alt="New" width="12" height="17" /><span>Foundation Course <Image src={gifImage} className="ml-1" alt="New" width="35" /></span>
                                                    </Link>
                                                </Nav.Item>
                                            )
                                        ) : (
                                            this.props.isuserValid.FoundationCourse == true ? ("") : (

                                                <Nav.Item>
                                                    <Link className={this.getActiveClass("/student/foundation-course/home")} to="/student/foundation-course/home" onClick={() => this.props.onClick()}>
                                                        <Image src={foundationNavIcon} className="ml-2" alt="New" width="12" height="17" /><span>Foundation Course <Image src={gifImage} className="ml-1" alt="New" width="35" /></span>
                                                    </Link>
                                                </Nav.Item>
                                            )
                                        )
                                    }
                                    {
                                        Cookies.get("student_userlevel") != "1" ? (
                                            this.props.isuserValid.Free_FoundationTests == true ? ("") : (
                                                <Nav.Item>
                                                    <Link className={this.getActiveClass("/student/ready-to-foundation-tests")} to="/student/ready-to-foundation-tests" onClick={() => this.props.onClick()}>
                                                        <Image src={foundationtest} className="ml-2" alt="New" width="15" height="15" /><span>Free Foundation Tests <Image src={gifImage} className="ml-1" alt="New" width="35" /></span>
                                                    </Link>
                                                </Nav.Item>

                                            )
                                        ) : (
                                            this.props.isuserValid.Free_FoundationTests == true ? ("") : (

                                                <Nav.Item>
                                                    <Link className={this.getActiveClass("/student/ready-to-foundation-tests")} to="/student/ready-to-foundation-tests" onClick={() => this.props.onClick()}>
                                                        <Image src={foundationtest} className="ml-2" alt="New" width="15" height="15" /><span>Free Foundation Tests <Image src={gifImage} className="ml-1" alt="New" width="35" /></span>
                                                    </Link>
                                                </Nav.Item>

                                            )
                                        )
                                    } */}

                                        {
                                            Cookies.get("toggle") == "wrapper sidebar-enable" && Cookies.get("student_userlevel") == 2 ?
                                                (<h6 className='nav_type_header'>PREPARATION</h6>)
                                                :
                                                ("")
                                        }


                                        {this.props.isuserValid.ins_linkage_analysis_tab == true ? ("") : (
                                            <Nav.Item>
                                                <Link className={this.getActiveClass("/student/linkage-chapter-analysis")} to="/student/linkage-chapter-analysis" onClick={() => this.props.onClick()}>
                                                    <i className="fal fa-link" title="Linkage Chapter Analysis" /><span>Linkage Chapter Analysis</span>
                                                </Link>
                                            </Nav.Item>
                                        )}
                                        {this.props.isuserValid.ins_previous_paper_analysis_tab == true ? ("") : (<Nav.Item>
                                            <Link className={this.getActiveClass("/student/previous-paper-analysis")} to="/student/previous-paper-analysis" onClick={() => this.props.onClick()}>
                                                <i className="fal fa-gift-card" title="Previous Paper Analysis" /><span>Previous Paper Analysis</span>
                                            </Link>
                                        </Nav.Item>)}

                                        {this.props.isuserValid.ins_learn_tab == true ? ("") : (<Nav.Item>
                                            <Link className={this.getActiveClass("/student/learn-practice")} to="/student/learn-practice" onClick={() => this.props.onClick()}>
                                                <i className="fal fa-book-reader" title="Learn &amp; Practice" /><span>Learn &amp; Practise</span>
                                            </Link>
                                        </Nav.Item>)}
                                        {this.props.isuserValid.ins_videos_tab == true ? ("") : (<Nav.Item>
                                            <Link className={this.getActiveClass("/student/category_wise_videos")} to="/student/category_wise_videos" onClick={() => this.props.onClick()}>
                                                <i className="fal fa-video" title="Videos" /> <span>Watch & Learn<Image src={pulseImage} className="ml-2" alt="New" width="20" /></span>
                                            </Link>
                                        </Nav.Item>)}
                                        {this.props.isuserValid.ins_revision_material_tab == true ? ("") : (<Nav.Item>
                                            <Link className={this.getActiveClass("/student/revision-material-groups")} to="/student/revision-material-groups" onClick={() => this.props.onClick()}>
                                                <i className="fal fa-books" title="Revision Materials" /> <span>Revision Material</span>
                                            </Link>
                                        </Nav.Item>)}

                                        {this.props.isuserValid.ins_exam_tab == true ? ("") : (<Nav.Item>
                                            <Link className={this.getActiveClass("/student/exams/quiz_exam")} to="/student/exams/quiz_exam" onClick={() => this.props.onClick()}>
                                                <i className="fas fa-question" title="Quiz &amp; Assignment" /> <span>Quiz</span>
                                            </Link>
                                        </Nav.Item>)}



                                        {
                                            Cookies.get("toggle") == "wrapper sidebar-enable" && Cookies.get("student_userlevel") == 2 ?
                                                (<h6 className='nav_type_header'>SELF EXAMINAION</h6>)
                                                :
                                                ("")
                                        }



                                        {this.props.isuserValid.ins_exam_tab == true ? ("") : (<Nav.Item>
                                            <Link className={this.getActiveClass("/student/exams")} to="/student/exams" onClick={() => this.props.onClick()}>
                                                <i className="fal fa-clipboard-list-check" title="Create Exam" /> <span>Create Exam</span>
                                            </Link>
                                        </Nav.Item>)}


                                        {
                                            Cookies.get("examid") == "2" && Cookies.get("student_userlevel") == 2 ?
                                                (
                                                    <>
                                                        <h6 className='nav_type_header'>ADMISSION</h6>
                                                        <Nav.Item>
                                                            <Link className={this.getActiveClass("/student/NTA-College_predictor")} to="/student/NTA-College_predictor">
                                                                <Image src={Quiz} className="ml-1" alt="New" width="15" height="15" /> <span>NTA College Predictor<Image src={gifImage} className="ml-1" alt="New" width="35" /></span>
                                                            </Link>
                                                        </Nav.Item>
                                                    </>
                                                )
                                                :
                                                ("")
                                        }
                                        {
                                            Cookies.get("toggle") == "wrapper sidebar-enable" && Cookies.get("student_userlevel") == 2 ?
                                                (<h6 className='nav_type_header'>OTHERS</h6>)
                                                :
                                                ("")
                                        }

                                        {/* <Nav.Item>
                                            <Link className={this.getActiveClass("/student/doubts")} to="/student/doubts" onClick={() => this.props.onClick()}>
                                                <i className="fal fa-question-circle" title="Doubts" /> <span>Doubts</span>
                                            </Link>
                                        </Nav.Item> */}
                                        {this.props.isuserValid.ins_package_tab == true ? ("") : (<React.Fragment>
                                            {Cookies.get("student_userlevel") != 1 ? (<Nav.Item>
                                                <Link className={this.getActiveClass("/student/package")} to="/student/package" onClick={() => this.props.onClick()}>
                                                    <i className="fal fa-sack" title="Package" /> <span>Subscription Plans</span>
                                                </Link>
                                            </Nav.Item>) : ("")}
                                        </React.Fragment>)}
                                        {
                                            Cookies.get("student_userlevel") != "1" ?
                                                (
                                                    <Nav.Item>
                                                        <Link className={this.getActiveClass("/student/referFriend")} to="/student/referFriend" onClick={() => this.props.onClick()}>
                                                            <i className="fal fa-clipboard-list-check" title="Refer Friend" /> <span>Refer a Friend</span>
                                                        </Link>
                                                    </Nav.Item>
                                                )
                                                :
                                                ("")
                                        }
                                        {this.props.isuserValid.ins_help_videos == true ? ("") : (<Nav.Item>
                                            <Link className={this.getActiveClass("/student/featuredvideos")} to="/student/featuredvideos" onClick={() => this.props.onClick()}>
                                                <i className="fal fa-video" title="Help Videos" /> <span>Help Videos</span>
                                            </Link>
                                        </Nav.Item>)}

                                        {this.props.isuserValid.ins_ready_exam_tab == false || this.props.isuserValid.ins_bookmarks_tab == false || this.props.isuserValid.ins_notes_tab == false ? (
                                            <React.Fragment>
                                                <Accordion.Toggle as={Nav.Item} eventKey={2} className="HasChild">
                                                    <a className="nav-link"
                                                    >
                                                        <i className="fal fa-cogs" title="Learning Tools" /> <span>Learning Tools</span>
                                                        <AccordionArrow eventKey={2} />
                                                    </a>
                                                </Accordion.Toggle>
                                                <Accordion.Collapse eventKey={2}>
                                                    <div className="collapse-inner">
                                                        {this.props.isuserValid.ins_ready_exam_tab == true ? ("") : (<Nav.Item>
                                                            <Link className={this.getActiveClassTwo("/student/get-ready-for-exam")} to="/student/get-ready-for-exam" onClick={() => this.props.onClick()}>
                                                                <i className="fal fa-running" title="Get Ready For Exam" /> <span>Get Ready For Exam</span>
                                                            </Link>
                                                        </Nav.Item>)}
                                                        {this.props.isuserValid.ins_bookmarks_tab == true ? ("") : (<Nav.Item>
                                                            <Link className={this.getActiveClassTwo("/student/bookmark")} to="/student/bookmark" onClick={() => this.props.onClick()}>
                                                                <i className="fal fa-bookmark" title="Bookmarks" /> <span>Bookmarks</span>
                                                            </Link>
                                                        </Nav.Item>)}

                                                        {this.props.isuserValid.ins_notes_tab == true ? ("") : (<Nav.Item>
                                                            <Link className={this.getActiveClassTwo("/student/notes")} to="/student/notes" onClick={() => this.props.onClick()}>
                                                                <i className="fal fa-book" title="Notes" /> <span>Notes</span>
                                                            </Link>
                                                        </Nav.Item>)}

                                                    </div>
                                                </Accordion.Collapse>
                                            </React.Fragment>
                                        ) : ("")}
                                        {/* Blog hidden from the side menu
                                        {this.props.isuserValid.ins_blog == true || this.props.isuserValid.institution_id == "46" || this.props.isuserValid.institution_id == "50" || this.props.isuserValid.institution_id == "51" ? ("") : (
                                            <Nav.Item>
                                                <Link className={this.getActiveClass("/student/student-blog")} to="/student/student-blog" onClick={() => this.props.onClick()}>
                                                    <i className="fal fa-blog" /><span>Blog</span>
                                                </Link>
                                            </Nav.Item>
                                        )}
                                        */}
                                        {/*this.props.isuserValid.ins_videos_tab == true ? ("") : (<Nav.Item>
                                        <Link className={this.getActiveClass("/student/videos")} to="/student/videos">
                                            <i className="fal fa-video" title="Videos" /> <span>Live Classes<Image src={pulseImage} className="ml-2" alt="New" width="20" /></span>
                                        </Link>
                                    </Nav.Item>)*/}

                                        {/* {
                                        Cookies.get("examid") == 1 ?
                                            (
                                                <Nav.Item>
                                                    <Link className={this.getActiveClass("/student/live_Test_series/exams")} to="/student/live_Test_series/exams">
                                                        <i className="fal fa-clipboard-list-check" title="NEET Crash Course" /> {Cookies.get("examid") == 1 ? (<><span> Live Test Series</span> <span className="label-bg">New</span></>) : ("")}
                                                    </Link>
                                                </Nav.Item>
                                            )
                                            :
                                            ("")
                                    } */}



                                        {/* {
                                        Cookies.get("examid") == 2 && this.props.isuserValid.ins_jee_mains_2021 == false ? (
                                            <Nav.Item>
                                                <Link className={this.getActiveClass("/student/createpreviouspaperexam")} to="/student/createpreviouspaperexam" onClick={() => this.props.onClick()}>
                                                    <i className="fal fa-clipboard-list-check" title="JEE Mains" /> <span>JEE Mains 2022<Image src={gifImage} className="ml-2" alt="New" width="40" /></span>
                                                </Link>
                                            </Nav.Item>
                                        ) : ("")
                                    } */}

                                        {/*
                                        Cookies.get("examid") == 1 ? (
                                            this.props.isuserValid.userlevel == 1 ? 
                                            (
                                                this.props.isuserValid.ins_rapid_revision != true ? 
                                                (
                                                    <Nav.Item>
                                                        <Link className={this.getActiveClass("/student/rapidRevision/liveClasses")} to="/student/rapidRevision/liveClasses">
                                                            <i className="fal fa-video" title="Rapid Revision" /> <span>Rapid Revision</span><span className="label-bg">NEET 2021</span>
                                                        </Link>
                                                    </Nav.Item>
                                                )
                                                :
                                                ("")
                                            ) 
                                            :
                                            (
                                                <Nav.Item>
                                                <Link className={this.getActiveClass("/student/rapidRevision/liveClasses")} to="/student/rapidRevision/liveClasses">
                                                    <i className="fal fa-video" title="Rapid Revision" /> <span>Rapid Revision</span><span className="label-bg">NEET 2021</span>
                                                </Link>
                                                </Nav.Item>
                                            )
                                               
                                         ) : ("")
                                    */}

                                        {/* {this.props.isuserValid.ins_package_tab == true ? ("") : (<React.Fragment>
                                        {Cookies.get("student_userlevel") != 1 ? (<Nav.Item>
                                            <Link className={this.getActiveClass("/student/cbse")} to="/student/cbse">
                                                <i className="far fa-book-open" title="jee Repeater" /> <span>CBSE 2021</span>
                                            </Link>
                                        </Nav.Item>) : ("")}
                                    </React.Fragment>)
                                    } */}


                                        {/* <hr className="sidebar-divider" /> */}
                                        {/* {this.props.isuserValid.ins_doubts_tab == true ? ("") : (
                                    
                                    <Nav.Item>
                                        <Link className={this.getActiveClass("/student/previous-paper-analysis")} onClick={() => this.forumLink()} onClick={() => this.props.onClick()}>
                                            <i className="fal fa-paper-plane" title="Doubts App" /> <span>Doubts App</span>
                                        </Link>
                                    </Nav.Item>
                                )} */}


                                    </Accordion>

                                </Nav>
                            ) : (
                                <Nav className="navbar-nav menu">
                                    <Accordion defaultActiveKey={this.getAccordianActive()}>
                                      {/* IIT Foundation entitlement. isuserValid comes from
                                          user_access_restictions, so the flag being true means RESTRICTED -
                                          same polarity as the Foundation Course item below. */}
                                      {this.props.isuserValid.FoundationCourse == true ? ("") : (
                                        <>
                                        {/* IIT FOUNDATION — shown to every student, no conditions */}
                                        <Nav.Item>
                                          <Link
                                            className={this.getActiveClass("/iit-foundation/student-dashboard")}
                                            to="/iit-foundation/student-dashboard"
                                            onClick={() => this.props.onClick()}
                                          >
                                            <Image
                                              src={CrashCourse}
                                              className="ml-2"
                                              alt="New"
                                              width="15"
                                              height="15"
                                            />
                                            <span>IIT FOUNDATION</span>
                                          </Link>
                                        </Nav.Item>

                                        {/* IIT Foundation Short Notes — shown to every student, no conditions */}
                                        <Nav.Item>
                                          <Link
                                            className={this.getActiveClass("/iit-foundation/short-notes")}
                                            to="/iit-foundation/short-notes"
                                            onClick={() => this.props.onClick()}
                                          >
                                            <Image
                                              src={ShortNotes}
                                              className="ml-2"
                                              alt="Short Notes"
                                              width="15"
                                              height="15"
                                            />
                                            <span>Short Notes</span>
                                          </Link>
                                        </Nav.Item>
                                        </>
                                      )}

                                        {
                                            Cookies.get("toggle") == "wrapper sidebar-enable" && Cookies.get("student_userlevel") == 2 ?
                                                (<h6 className='nav_type_header'>TEST PREP BUNDLE</h6>)
                                                :
                                                ("")
                                        }
                                        {this.props.isuserValid.userlevel == 1 ? (
                                            this.props.isuserValid.PreviousYearMockTest != true ? (
                                                <Nav.Item>
                                                    <Link className={this.getActiveClass("/student/previouspaperexams")} to="/student/previouspaperexams" onClick={() => this.props.onClick()}>
                                                        <i className="fal fa-clipboard-list-check" title="Previous papers" /> <span>Previous Year Papers</span>
                                                    </Link>
                                                </Nav.Item>
                                            ) : ("")
                                        ) : (
                                            <Nav.Item>
                                                <Link className={this.getActiveClass("/student/previouspaperexams")} to="/student/previouspaperexams" onClick={() => this.props.onClick()}>
                                                    <i className="fal fa-clipboard-list-check" title="Previous papers" /> <span>Previous Year Papers</span>
                                                </Link>
                                            </Nav.Item>
                                        )}
                                        {
                                            Cookies.get("examid") == 2 ? (
                                                this.props.isuserValid.ins_mock_test == true ? ("") : (<Nav.Item>

                                                    <Link className={this.getActiveClass("/student/exams/test-series")} to="/student/exams/test-series" onClick={() => this.props.onClick()}>
                                                        <i className="fal fa-badge-check" title="Exams History" /> <span>Mock Tests with Analysis</span>
                                                    </Link>

                                                </Nav.Item>)

                                            ) : ("")
                                        }
                                        {
                                            Cookies.get("examid") == 1 ? (
                                                this.props.isuserValid.userlevel == 1 ?
                                                    (
                                                        this.props.isuserValid.ins_mock_test_nta != true ?
                                                            (
                                                                <Nav.Item>
                                                                    <Link className={this.getActiveClass("/student/exams/test-series/NewNTAPattern")} to="/student/exams/test-series/NewNTAPattern" onClick={() => this.props.onClick()}>
                                                                        <i className="fal fa-clipboard-list-check" title="New NTA Pattern" /> <span>Mock Tests with Analysis</span>
                                                                    </Link>
                                                                </Nav.Item>
                                                            )
                                                            :
                                                            ("")
                                                    )
                                                    :
                                                    (
                                                        <Nav.Item>
                                                            <Link className={this.getActiveClass("/student/exams/test-series/NewNTAPattern")} to="/student/exams/test-series/NewNTAPattern" onClick={() => this.props.onClick()}>
                                                                <i className="fal fa-clipboard-list-check" title="New NTA Pattern" /> <span>Mock Tests with Analysis</span>
                                                            </Link>
                                                        </Nav.Item>
                                                    )
                                            ) : ("")

                                        }
                                        {this.props.isuserValid.error_exam == true ? ("") : (<Nav.Item>
                                            <Link className={this.getActiveClass("/student/exams/error-exam")} to="/student/exams/error-exam">
                                                <i className="fas fa-exclamation-circle" title="Error Exam" /> <span>Error Exam</span>
                                            </Link>
                                        </Nav.Item>)}

                                        {this.props.isuserValid.ins_analysis_tab == true ? ("") : (
                                            <Nav.Item>
                                                <Link className={this.getActiveClass("/student/result-analysis")} to="/student/result-analysis" onClick={() => this.props.onClick()}>
                                                    <i className="fal fa-analytics" title="Result &amp; Analysis" /><span>Performance Analysis</span>
                                                </Link>
                                            </Nav.Item>

                                        )}

                                        {this.props.isuserValid.ins_analysis_tab == true ? ("") : (
                                            <Nav.Item>
                                                <Link className={this.getActiveClass("/student/performance-report")} to="/student/performance-report" onClick={() => this.props.onClick()}>
                                                    <i className="fas fa-chart-line" title="Result &amp; Report" /><span>Performance Report</span>
                                                </Link>
                                            </Nav.Item>
                                        )}

                                        {Cookies.get("institution_id") == 51 && (Cookies.get("examid") == 27 || Cookies.get("examid") == 28 || Cookies.get("examid") == 29) ? (
                                            <>
                                                <h6 className="nav_type_header group_type ">IIT FOUNDATION</h6>
                                                <Nav.Item>
                                                    <Link className={this.getActiveClass("/student/iit-foundation-course/videos")} to="/student/iit-foundation-course/videos" onClick={() => this.props.onClick()}>
                                                        <Image src={foundationNavIcon} className="ml-2" alt="New" width="12" height="17" /><span>Videos <Image src={gifImage} className="ml-1" alt="New" width="35" /></span>
                                                    </Link>
                                                </Nav.Item>
                                                <Nav.Item>
                                                    <Link className={this.getActiveClass("/student/iit-foundation-course/notes")} to="/student/iit-foundation-course/notes" onClick={() => this.props.onClick()}>
                                                        <Image src={foundationNavIcon} className="ml-2" alt="New" width="12" height="17" /><span>Notes <Image src={gifImage} className="ml-1" alt="New" width="35" /></span>
                                                    </Link>
                                                </Nav.Item>
                                                <Nav.Item>
                                                    <Link className={this.getActiveClass("/student/iit-foundation-course/tests")} to="/student/iit-foundation-course/tests" onClick={() => this.props.onClick()}>
                                                        <Image src={foundationNavIcon} className="ml-2" alt="New" width="12" height="17" /><span>Tests <Image src={gifImage} className="ml-1" alt="New" width="35" /></span>
                                                    </Link>
                                                </Nav.Item>
                                                <Nav.Item>
                                                    <Link className={this.getActiveClass("/student/iit-foundation-course/practice")} to="/student/iit-foundation-course/practice" onClick={() => this.props.onClick()}>
                                                        <Image src={foundationNavIcon} className="ml-2" alt="New" width="12" height="17" /><span>Practice <Image src={gifImage} className="ml-1" alt="New" width="35" /></span>
                                                    </Link>
                                                </Nav.Item>
                                                <Nav.Item>
                                                    <Link className={this.getActiveClass("/student/iit-foundation-course/analysis")} to="/student/iit-foundation-course/analysis" onClick={() => this.props.onClick()}>
                                                        <Image src={foundationNavIcon} className="ml-2" alt="New" width="12" height="17" /><span>Analysis <Image src={gifImage} className="ml-1" alt="New" width="35" /></span>
                                                    </Link>
                                                </Nav.Item>
                                                <Nav.Item>
                                                    <Link className={this.getActiveClass("/student/iit-foundation-course/error-exams")} to="/student/iit-foundation-course/videos" onClick={() => this.props.onClick()}>
                                                        <Image src={foundationNavIcon} className="ml-2" alt="New" width="12" height="17" /><span>Error Exams <Image src={gifImage} className="ml-1" alt="New" width="35" /></span>
                                                    </Link>
                                                </Nav.Item>
                                            </>
                                        ) : ("")}

                                    </Accordion>

                                </Nav>
                            )
                        )

                    }
                </Scrollbars>
                <p className="product_brand text-center"> Powered by  <span className="product_brand_sub">Rizee</span></p>
                {/* <StartingModal show={this.state.StartingModalShow} onHide={this.onHide} isuserValid={this.props.isuserValid} />
                {
                    this.state.targetPopupData.pop_enabled == true ?
                        (
                            <StudentTargettingPopup
                                show={this.state.targetPopup}
                                onHide={this.onHide}
                                targetPopupData={this.state.targetPopupData}
                            />
                        )
                        :
                        ("")
                } */}
            </React.Fragment>
        )
    }
}

export default withRouter(compose(
    graphql(GET_CROSSSELLING_POPUP,
        {
            options: props => ({
                variables: {
                    mobile: Cookies.get("mobile"),
                    app_module_id: 1,
                    source: 2
                }
                ,
                fetchPolicy: "network-only"
            }), name: "getCrossSellingEnabled"
        }),
)(MobileAsideNavbar));